if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        console.log('MediaGallery: Constructor called');
        
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        
        console.log('MediaGallery: Elements found:', this.elements);
        
        this.mql = window.matchMedia('(min-width: 750px)');
        this.isMobile = window.matchMedia('(max-width: 749px)').matches;
        console.log('MediaGallery: Media query (desktop):', this.mql.matches);
        console.log('MediaGallery: Is mobile:', this.isMobile);
        
        if (!this.elements.thumbnails) {
          console.log('MediaGallery: No thumbnails found, exiting early');
          return;
        }

        console.log('MediaGallery: Adding event listeners');
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        
        const mediaToSwitchElements = this.elements.thumbnails.querySelectorAll('[data-target]');
        console.log('MediaGallery: Found media switch elements:', mediaToSwitchElements.length);
        
        mediaToSwitchElements.forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          console.log('MediaGallery: Removing list semantic for desktop thumbnail layout');
          this.removeListSemantic();
        }
        
        // NEW: Initialize video enhancement for current active slide
        this.initializeMobileVideo();
        
        // NEW: Enhance deferred media for auto-play
        this.enhanceDeferredMedia();
        
        // NEW: Handle modal videos
        this.handleModalVideos();
        
        console.log('MediaGallery: Initialization complete');
      }

      // NEW: Initialize mobile video for the currently active slide
      initializeMobileVideo() {
        if (!this.isMobile) {
          console.log('MediaGallery: Not mobile, skipping video initialization');
          return;
        }
        
        console.log('MediaGallery: Initializing mobile video for active slide');
        const activeSlide = this.elements.viewer.querySelector('.slider__slide.is-active');
        if (activeSlide) {
          this.enhanceVideoSlide(activeSlide);
        }
      }

      onSlideChanged(event) {
        console.log('MediaGallery: Slide changed event:', event.detail);
        
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        
        console.log('MediaGallery: Found thumbnail for active slide:', thumbnail);
        this.setActiveThumbnail(thumbnail);
        
        // NEW: Handle mobile video enhancement for new slide
        if (this.isMobile) {
          console.log('MediaGallery: Mobile detected, cleaning up and enhancing video');
          this.cleanupInactiveVideos();
          this.enhanceVideoSlide(event.detail.currentElement);
        }
      }

      setActiveMedia(mediaId, prepend) {
        console.log('MediaGallery: Setting active media:', { mediaId, prepend });
        
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        console.log('MediaGallery: Found active media element:', activeMedia);
        
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');
        console.log('MediaGallery: Set is-active class on media element');

        if (prepend) {
          console.log('MediaGallery: Prepending active media to front');
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        console.log('MediaGallery: Preventing sticky header');
        this.preventStickyHeader();
        
        window.setTimeout(() => {
          console.log('MediaGallery: Executing scroll timeout');
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        
        console.log('MediaGallery: Playing active media');
        this.playActiveMedia(activeMedia);

        // NEW: Handle mobile video enhancement for manually set media
        if (this.isMobile) {
          console.log('MediaGallery: Mobile detected, cleaning up and enhancing video for setActiveMedia');
          this.cleanupInactiveVideos();
          this.enhanceVideoSlide(activeMedia);
        }

        if (!this.elements.thumbnails) {
          console.log('MediaGallery: No thumbnails, skipping thumbnail operations');
          return;
        }
        
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        console.log('MediaGallery: Found active thumbnail:', activeThumbnail);
        
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      // NEW: Enhanced video slide functionality
      enhanceVideoSlide(slide) {
        if (!slide) {
          console.log('MediaGallery: No slide provided for video enhancement');
          return;
        }
        
        console.log('MediaGallery: Enhancing slide for mobile video:', slide);
        
        // Check if this slide has a video
        const modalOpener = slide.querySelector('modal-opener.product__modal-opener--video');
        if (!modalOpener) {
          console.log('MediaGallery: No video modal opener found, skipping');
          return;
        }
        
        // Check if already enhanced
        if (slide.querySelector('.mobile-background-video')) {
          console.log('MediaGallery: Slide already enhanced with background video');
          return;
        }
        
        console.log('MediaGallery: Found video modal opener, extracting video URL');
        const videoUrl = this.extractVideoUrl(slide);
        
        if (videoUrl) {
          console.log('MediaGallery: Video URL extracted:', videoUrl);
          this.createMobileBackgroundVideo(slide, modalOpener, videoUrl);
        } else {
          console.log('MediaGallery: Could not extract video URL');
        }
      }

      // NEW: Extract video URL from slide
      extractVideoUrl(slide) {
        try {
          // Method 1: Look in deferred media template
          const deferredMedia = slide.querySelector('deferred-media template');
          if (deferredMedia) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = deferredMedia.innerHTML;
            const videoSource = tempDiv.querySelector('video source');
            if (videoSource && videoSource.src) {
              console.log('MediaGallery: Video URL found in deferred media template');
              return videoSource.src;
            }
          }
          
          // Method 2: Look for direct video link in noscript
          const videoLink = slide.querySelector('noscript a[href*=".mp4"]');
          if (videoLink) {
            console.log('MediaGallery: Video URL found in noscript link');
            return videoLink.href;
          }
          
          console.log('MediaGallery: No video URL found in slide');
          return null;
        } catch (error) {
          console.error('MediaGallery: Error extracting video URL:', error);
          return null;
        }
      }

      // NEW: Create mobile background video
      createMobileBackgroundVideo(slide, modalOpener, videoUrl) {
        console.log('MediaGallery: Creating mobile background video');
        
        const mediaContainer = modalOpener.querySelector('.product__media');
        const originalImage = modalOpener.querySelector('img');
        
        if (!mediaContainer || !originalImage) {
          console.log('MediaGallery: Missing required elements for video creation');
          return;
        }
        
        // Create video element
        const video = document.createElement('video');
        video.className = 'mobile-background-video';
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'metadata';
        
        // Style the video
        video.style.cssText = `
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          opacity: 0;
          transition: opacity 0.6s ease;
          z-index: 0;
          pointer-events: none;
        `;
        
        // Video event listeners
        video.addEventListener('loadeddata', () => {
          console.log('MediaGallery: Video loaded successfully, fading in');
          originalImage.style.transition = 'opacity 0.6s ease';
          originalImage.style.opacity = '0.1'; // Keep very faint for fallback
          video.style.opacity = '1';
          
          // Slightly fade the play icon but keep it visible
          const playIcon = modalOpener.querySelector('.product__media-icon');
          if (playIcon) {
            playIcon.style.transition = 'opacity 0.3s ease';
            playIcon.style.opacity = '0.4';
          }
        });
        
        video.addEventListener('error', (e) => {
          console.error('MediaGallery: Video failed to load:', e);
          // Remove failed video and restore image
          video.remove();
          originalImage.style.opacity = '1';
        });
        
        video.addEventListener('canplay', () => {
          video.play().catch(e => {
            console.warn('MediaGallery: Video autoplay failed:', e);
            // Keep image visible as fallback
          });
        });
        
        // Position container as relative
        mediaContainer.style.position = 'relative';
        
        // Insert video
        mediaContainer.insertBefore(video, originalImage.nextSibling);
        
        // Set video source and load
        video.src = videoUrl;
        video.load();
        
        console.log('MediaGallery: Mobile background video created and loading');
      }

      // NEW: Clean up inactive videos
      cleanupInactiveVideos() {
        const inactiveSlides = this.elements.viewer.querySelectorAll('.slider__slide:not(.is-active)');
        
        inactiveSlides.forEach(slide => {
          const video = slide.querySelector('.mobile-background-video');
          if (video) {
            console.log('MediaGallery: Removing video from inactive slide');
            video.pause();
            video.remove();
            
            // Restore original image and play icon
            const originalImage = slide.querySelector('modal-opener img');
            const playIcon = slide.querySelector('.product__media-icon');
            
            if (originalImage) {
              originalImage.style.opacity = '1';
              originalImage.style.transition = '';
            }
            
            if (playIcon) {
              playIcon.style.opacity = '';
              playIcon.style.transition = '';
            }
          }
        });
      }

      // NEW: Enhance deferred media for auto-play behavior
      enhanceDeferredMedia() {
        console.log('MediaGallery: Enhancing deferred media components');
        
        const deferredMediaElements = this.querySelectorAll('deferred-media');
        
        deferredMediaElements.forEach(deferredMedia => {
          console.log('MediaGallery: Enhancing deferred media:', deferredMedia);
          
          // Override the loadContent method to auto-play and remove poster
          if (deferredMedia.loadContent) {
            const originalLoadContent = deferredMedia.loadContent.bind(deferredMedia);
            
            deferredMedia.loadContent = (focus = true) => {
              console.log('MediaGallery: Custom loadContent called');
              
              // Call original method first
              originalLoadContent(focus);
              
              // Then enhance the loaded video
              setTimeout(() => {
                this.enhanceLoadedVideo(deferredMedia);
              }, 100); // Small delay to ensure video is in DOM
            };
          }
          
          // Also enhance any existing poster buttons
          const posterButton = deferredMedia.querySelector('.deferred-media__poster');
          if (posterButton) {
            console.log('MediaGallery: Found poster button, enhancing click behavior');
            
            // Add our custom click handler
            posterButton.addEventListener('click', (e) => {
              console.log('MediaGallery: Poster button clicked - will auto-play video');
              
              // Let the original handler run first, then enhance
              setTimeout(() => {
                this.enhanceLoadedVideo(deferredMedia);
              }, 150);
            });
          }
          
        });
        
        // NEW: Also handle video loading within modals
        this.handleModalVideos();
      }

      // NEW: Handle video auto-loading within modals
      handleModalVideos() {
        console.log('MediaGallery: Setting up modal video handlers');
        
        const modals = document.querySelectorAll('product-modal');
        
        modals.forEach(modal => {
          const deferredMediaElements = modal.querySelectorAll('deferred-media[data-media-id]');
          
          if (deferredMediaElements.length === 0) return;
          
          // Use a single observer per modal
          const observer = new MutationObserver((mutations) => {
            const isOpened = mutations.some(mutation => 
              mutation.type === 'attributes' && 
              mutation.attributeName === 'open' && 
              modal.hasAttribute('open')
            );
            
            if (isOpened) {
              console.log('MediaGallery: Modal opened, auto-loading videos');
              deferredMediaElements.forEach(deferredMedia => {
                if (!deferredMedia.classList.contains('loaded')) {
                  this.autoLoadVideoInModal(deferredMedia);
                }
              });
            }
          });
          
          observer.observe(modal, {
            attributes: true,
            attributeFilter: ['open']
          });
          
          // Handle already open modals
          if (modal.hasAttribute('open')) {
            deferredMediaElements.forEach(deferredMedia => {
              if (!deferredMedia.classList.contains('loaded')) {
                setTimeout(() => this.autoLoadVideoInModal(deferredMedia), 100);
              }
            });
          }
        });
      }

      // NEW: Auto-load video from template when modal opens
      autoLoadVideoInModal(deferredMedia) {
        console.log('MediaGallery: Auto-loading video in modal');
        
        const template = deferredMedia.querySelector('template');
        if (!template?.innerHTML) {
          console.log('MediaGallery: No template content found');
          return;
        }
        
        // Extract video from template
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = template.innerHTML;
        const videoElement = tempDiv.querySelector('video');
        
        if (!videoElement) {
          console.log('MediaGallery: No video in template');
          return;
        }
        
        // Clone and configure video
        const video = videoElement.cloneNode(true);
        video.removeAttribute('poster');
        video.autoplay = true;
        video.muted = false;
        video.controls = true;
        video.playsInline = true;
        video.loop = true; // Add looping
        
        // Apply modal-optimized styling
        Object.assign(video.style, {
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          background: '#000'
        });
        
        // Replace template with video
        deferredMedia.innerHTML = '';
        deferredMedia.appendChild(video);
        
        // Auto-play with fallback
        const playVideo = () => {
          video.play()
            .then(() => console.log('MediaGallery: Video playing'))
            .catch(() => {
              video.muted = true;
              video.play().catch(e => console.error('MediaGallery: Video play failed:', e));
            });
        };
        
        if (video.readyState >= 3) {
          playVideo();
        } else {
          video.addEventListener('loadeddata', playVideo, { once: true });
        }
        
        deferredMedia.classList.add('loaded');
        console.log('MediaGallery: Video loaded in modal');
      }

      // NEW: Enhance the loaded video for auto-play and poster removal
      enhanceLoadedVideo(deferredMedia) {
        console.log('MediaGallery: Enhancing loaded video in deferred media');
        
        const video = deferredMedia.querySelector('video');
        if (!video) {
          console.log('MediaGallery: No video found in deferred media yet');
          return;
        }
        
        console.log('MediaGallery: Video found, applying enhancements:', video);
        
        // Remove poster attribute to prevent poster display
        if (video.poster) {
          console.log('MediaGallery: Removing video poster');
          video.poster = '';
          video.removeAttribute('poster');
        }
        
        // Ensure autoplay is enabled
        video.autoplay = true;
        video.muted = false; // User interaction allows unmuted autoplay
        
        // Force play the video
        const playVideo = () => {
          console.log('MediaGallery: Attempting to play video');
          const playPromise = video.play();
          
          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                console.log('MediaGallery: Video auto-play successful');
              })
              .catch(error => {
                console.warn('MediaGallery: Video auto-play failed:', error);
                // Fallback: try with muted
                video.muted = true;
                video.play().catch(e => {
                  console.error('MediaGallery: Even muted video play failed:', e);
                });
              });
          }
        };
        
        // Try to play immediately
        if (video.readyState >= 3) { // HAVE_FUTURE_DATA
          playVideo();
        } else {
          // Wait for video to be ready
          video.addEventListener('canplay', playVideo, { once: true });
          video.addEventListener('loadeddata', playVideo, { once: true });
        }
        
        // Also hide the poster button since video will auto-play
        const posterButton = deferredMedia.querySelector('.deferred-media__poster');
        if (posterButton) {
          console.log('MediaGallery: Hiding poster button since video will auto-play');
          posterButton.style.display = 'none';
        }
      }

      // EXISTING METHODS (unchanged)
      setActiveThumbnail(thumbnail) {
        console.log('MediaGallery: Setting active thumbnail:', thumbnail);
        
        if (!this.elements.thumbnails || !thumbnail) {
          console.log('MediaGallery: No thumbnails or thumbnail element, skipping');
          return;
        }

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        
        console.log('MediaGallery: Set aria-current on thumbnail button');
        
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          console.log('MediaGallery: Thumbnail already visible, no scroll needed');
          return;
        }

        console.log('MediaGallery: Scrolling thumbnails to make active visible');
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        console.log('MediaGallery: Announcing live region for position:', position);
        
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) {
          console.log('MediaGallery: No image found for live region announcement');
          return;
        }
        
        image.onload = () => {
          console.log('MediaGallery: Image loaded, updating live region');
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
            console.log('MediaGallery: Live region hidden after timeout');
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        console.log('MediaGallery: Playing active media for item:', activeItem);
        
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        
        if (deferredMedia) {
          console.log('MediaGallery: Found deferred media, loading content');
          deferredMedia.loadContent(false);
        } else {
          console.log('MediaGallery: No deferred media found');
        }
      }

      preventStickyHeader() {
        console.log('MediaGallery: Preventing sticky header reveal');
        
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) {
          console.log('MediaGallery: No sticky header found');
          return;
        }
        
        console.log('MediaGallery: Dispatching preventHeaderReveal event');
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        console.log('MediaGallery: Removing list semantic');
        
        if (!this.elements.viewer.slider) {
          console.log('MediaGallery: No slider found, cannot remove list semantic');
          return;
        }
        
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
        
        console.log('MediaGallery: List semantic removed from slider and slides');
      }
    }
  );
  
  console.log('MediaGallery: Custom element defined successfully');
}